const RELOAD_KEY = "papier:chunk-reload-at";
const RELOAD_COOLDOWN_MS = 60_000;

// A deployment can remove a lazy chunk that an already-open tab still references.
// Reload once to fetch the current entry point, but leave persistent failures to
// the router's error boundary rather than trapping the user in a reload loop.
export function installChunkLoadRecovery(
  browser: {
    addEventListener: Window["addEventListener"];
    sessionStorage: Storage;
    location: Pick<Location, "reload">;
  } = window,
) {
  browser.addEventListener("vite:preloadError", (event) => {
    try {
      const now = Date.now();
      const previous = browser.sessionStorage.getItem(RELOAD_KEY);
      if (previous !== null && now - Number(previous) < RELOAD_COOLDOWN_MS) return;
      browser.sessionStorage.setItem(RELOAD_KEY, String(now));
      browser.location.reload();
      event.preventDefault();
    } catch {
      // Storage can be blocked. Without a persistent guard, do not auto-reload.
    }
  });
}
